import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggleFAQ = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">
            关于火影西瓜，你想知道的都在这里
          </p>
        </div>
        <div className="space-y-3">
          {faqItems.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="font-medium text-sm md:text-base text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-400">
                  <i
                    className={`ri-${
                      openId === faq.id ? 'subtract' : 'add'
                    }-line text-lg transition-transform`}
                  ></i>
                </span>
              </button>
              {openId === faq.id && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}